import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const GATE_CODE = '7887';
const UNLOCK_KEY = 'siteUnlocked';

interface Props {
  onUnlock: () => void;
}

const SiteGatePage = ({ onUnlock }: Props): JSX.Element => {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code === GATE_CODE) {
      localStorage.setItem(UNLOCK_KEY, 'true');
      onUnlock();
    } else {
      setError(true);
      setCode('');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        px: 2,
      }}
    >
      <Box
        component="img"
        src="/assets/logo.png"
        alt="Docket"
        sx={{ width: '100%', maxWidth: 280 }}
      />

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          width: '100%',
          maxWidth: 280,
        }}
      >
        <TextField
          value={code}
          onChange={(e) => {
            setError(false);
            setCode(e.target.value);
          }}
          placeholder="Enter code"
          inputProps={{ maxLength: 10 }}
          error={error}
          helperText={error ? 'Incorrect code' : ''}
          fullWidth
          sx={{
            '& input': { textAlign: 'center', letterSpacing: 4, fontSize: 20 },
            '& .MuiFormHelperText-root': { textAlign: 'center' },
          }}
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ py: 1.5, fontWeight: 600 }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default SiteGatePage;
